import IosShareIcon from '@mui/icons-material/IosShare';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Button, IconButton, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useInstall } from '../hooks/useInstall';

const DISMISSED_KEY = 'ponyup-install-hint-dismissed';

/**
 * Nudge toward installing, shown until dismissed. The instructions themselves
 * live on /install; this only has to get people there.
 *
 * Load-bearing rather than polish: on iOS, web push only reaches an installed
 * app, so notifications depend on someone following those steps.
 */
export function InstallHint() {
    const { installed } = useInstall();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (localStorage.getItem(DISMISSED_KEY) === '1') return;
        if (installed) return;
        setVisible(true);
    }, [installed]);

    if (!visible) return null;

    const dismiss = (): void => {
        localStorage.setItem(DISMISSED_KEY, '1');
        setVisible(false);
    };

    return (
        <Alert
            severity="info"
            icon={<IosShareIcon fontSize="small" />}
            sx={{ mb: 2 }}
            action={
                <IconButton aria-label="Dismiss install tip" size="small" onClick={dismiss}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        >
            <Stack spacing={1} alignItems="flex-start">
                <Typography variant="body2">
                    Put Pony Up on your home screen — it opens like an app, and notifications
                    only work once you do.
                </Typography>
                <Button component={RouterLink} to="/install" size="small" variant="outlined">
                    Show me how
                </Button>
            </Stack>
        </Alert>
    );
}
